import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import { IDrafts } from '@/interfaces/drafts.interface';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

interface IDrafstPageProps {
  books: IDrafts;
}

const Drafts: FC<IDrafstPageProps> = ({ books }) => {
  const pagesCount = Math.ceil(books.total_count / BOOKS_FOR_PAGE);
  const pageUrl = useGetUrlPath();

  //seo block
  const SEO_TITLE = 'Черновики книг в жанре фантастика и фэнтези читать онлайн или скачать бесплатно';
  const SEO_DESCRIPTION = 'Cкачать или читать онлайн черновики книг в жанре фантастика и фэнтези. Лучшие фантастические черновики можно скачать в fb2, epub, pdf или почитать онлайн на Fantasy Worlds';
  const SEO_CANONICAL = '/drafts/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={pageUrl}>
      <Breadcrumbs firstPageName="Черновики в жанре фантастика и фэнтези" />
      <Pagination pagesCount={pagesCount ?? 0} postName={`drafts/`} />
      <SectionTitle name="Черновики в жанре фантастика и фэнтези" />

      {books.data.length ? (
        books?.data.map((book) => {
          return (
            <BookCardItem
              createdAt={book.created_at}
              id={book.id}
              rating={book.rating}
              key={book.id}
              author={{ first_name: book.author.first_name, middle_name: book.author.middle_name, last_name: book.author.last_name, id: book.author.id }}
              hideLitresData={false}
              comments={book.comment_count}
              draft={book.draft}
              title={book.title}
              type={book.type}
              description={book.description}
              genres={book.genres}
              allow_full_free={book.allow_full_free}
              external_id={book.external_id}
            />
          );
        })
      ) : (
        <div>Книги не найдены</div>
      )}
      <Pagination pagesCount={pagesCount ?? 0} postName={`drafts/`} />
    </Layout>
  );
};

export default Drafts;
